/**
 * @file transfer-row-text.ts
 * @description Подписи строки и причины блокировки документа «Перемещение»
 * (phase19.24 этап 1, шаг 1).
 *
 * Тексты живут отдельно от вёрстки: одну и ту же фразу показывают таблица на
 * `≥lg` и карточка на `<lg`.
 *
 * Причина блокировки проведения уехала в общий `components/wms/document-texts`:
 * фраза «Добавьте хотя бы одну строку» обязана быть одна на приёмку, списание
 * и перемещение (замечание ревью 2026-09-20).
 */

import { lotLabel } from "../document-texts";
import type { TransferItemDto } from "../../../lib/api-transfers";
import { isIntraWarehouseRow } from "../../../lib/transfer-rows";

/**
 * «L-240901 · до 01.09.2026» — партия со сроком одной строкой.
 *
 * Снимок номера в строке (`lotBatchNumber`) может быть пустым у старых
 * документов — тогда берём номер живой партии. Формат общий с приёмкой и
 * списанием (`lotLabel`).
 */
export function transferLotLabel(item: TransferItemDto): string {
  return lotLabel(
    item.lotBatchNumber || item.lot?.batchNumber,
    item.lot?.expiresAt,
  );
}

/** «A-03-02» или «без ячейки» — откуда едет строка (снимок на момент строки). */
export function transferSourceLabel(item: TransferItemDto): string {
  return item.fromBinCode ?? "без ячейки";
}

/** «A-03-02» или «Склад №2 · B-01» — куда едет строка, текстом. */
export function transferTargetText(
  item: TransferItemDto,
  fromWarehouseId: string,
): string {
  if (isIntraWarehouseRow(item, fromWarehouseId)) {
    return item.toBinCode ?? item.toBin?.code ?? "не заполнено";
  }
  const warehouse = item.toWarehouse?.name ?? item.toWarehouseName ?? "склад";
  return item.toBinCode ? `${warehouse} · ${item.toBinCode}` : warehouse;
}
